import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';
import Header from './Header';

const Terms = () => {
  return (
    <div>
      {/* Floating background elements */}
      <div className="floating-elements">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
      </div>

      <Header />
      

      <div className="container">
        <div className="page-header">
          <div className="app-icon">
            <img src="croqly-logo.jpeg" alt="Croqly App Icon" />
          </div>
          <h1 className="page-title">Terms of Service</h1>
          <p className="page-subtitle">Croqly – Crochet & Knitting Companion</p>
          <div className="last-updated">Effective Date: November 23, 2025<br />Last Updated: November 23, 2025</div>
        </div>

        <main className="content">
          <h2>1. Agreement to Terms</h2>
          <p>By downloading, installing, or using Croqly ("App"), you ("User") agree to be bound by these Terms of Service ("Terms") and our [Privacy Policy]. If you do not agree, please do not use the App.</p>
          <p>These Terms constitute a legally binding agreement between you and Croqly ("Company," "we," "us," or "our") governing your use of the App and related services.</p>

          <h2>2. Eligibility & Account Registration</h2>
          <p>You must be at least 13 years old (or the minimum legal age in your country) to use the App.</p>
          <p>If you are under 18, you represent that you have obtained parental or guardian consent to use the App.</p>
          <p>You are responsible for maintaining the confidentiality of your account credentials and all activity under your account. You agree to notify us immediately of any unauthorized use of your account.</p>

          <h2>2.1. Firebase Anonymous Authentication</h2>
          <p>To comply with Apple’s account and data protections, Croqly uses Google Firebase Authentication to create an anonymous identifier the first time you open the App.</p>
          <ul>
            <li>No name, email, or phone number is required; Firebase issues a random anonymous UID.</li>
            <li>The UID lets us keep your progress, stash data, and purchases synced securely between sessions and devices that share the same Apple ID.</li>
            <li>Firebase Authentication is operated by Google LLC and follows its <a href="https://firebase.google.com/terms" target="_blank" rel="noopener noreferrer">Terms</a> and <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</li>
          </ul>
          <p>By using the App you authorize Croqly to rely on Firebase Authentication for identity management. You may delete this anonymous account at any time through the in-app data deletion option or by contacting us at itarnaevents2@gmail.com.</p>

          <h2>3. License Grant</h2>
          <p>We grant you a limited, non-exclusive, non-transferable, revocable license to use the App for personal, non-commercial crochet and knitting purposes, in compliance with these Terms and Apple's App Store policies.</p>
          <p>All rights not expressly granted to you are reserved by the Company.</p>

          <h2>4. Freemium Model & In-App Purchases</h2>
          <p>The App operates under a freemium model:</p>
          <p><strong>Free Features:</strong> basic pattern browsing and essential tools</p>
          <p><strong>Premium (Croqly Pro):</strong> requires a paid subscription and includes:</p>
          <ul>
            <li>Advanced crochet and knitting patterns with tutorials</li>
            <li>Smart progress tracking and streak monitoring</li>
            <li>Stash management (yarn, hooks, needles inventory)</li>
            <li>Advanced tools (row counter, stitch & yarn calculators, converters)</li>
            <li>Pattern guides, abbreviation references, and work-mode features</li>
          </ul>
          <p><strong>Subscription Plans:</strong></p>
          <ul>
            <li>Weekly: $4.99 per week</li>
            <li>Annual: $29.99 per year (save 88%)</li>
          </ul>
          <p>Subscriptions are billed to your Apple ID and renew automatically unless canceled at least 24 hours before renewal. You can manage or cancel your subscription anytime in:<br />
          Settings › Apple ID › Subscriptions.</p>
          <p>Prices may change with reasonable notice. You may cancel before any price increase takes effect. All purchases are final, and Apple handles all billing and refund requests.</p>
          <p>In-app purchases and subscriptions are processed through Apple's App Store. Apple is not responsible for the operation or support of the App but manages payments and refunds in accordance with its policies.</p>

          <h2>4.1. Subscription Services</h2>
          <h3>Subscription Plans</h3>
          <p>Croqly offers the following subscription plans:</p>
          <ul>
            <li><strong>Weekly Premium Plan:</strong> $4.99 per week</li>
            <li><strong>Annual Premium Plan:</strong> $29.99 per year</li>
          </ul>
          
          <h3>Subscription Features</h3>
          <p>Premium subscribers have access to:</p>
          <ul>
            <li>Unlimited access to all crochet patterns and tutorials</li>
            <li>Step-by-step crochet and amigurumi tutorials</li>
            <li>Pattern organization and management tools</li>
            <li>Progress tracking and work session management</li>
            <li>Yarn, hooks, and needles stash organization</li>
            <li>Essential crochet utilities and calculators</li>
            <li>Ad-free experience</li>
            <li>Priority customer support</li>
          </ul>

          <h2>5. User Content</h2>
          <p><strong>a. Ownership</strong><br />
          You retain full ownership of all patterns, images, notes, project progress, stash data, and other content you create or upload ("User Content").</p>
          <p><strong>b. License to Us</strong><br />
          You grant the Company a worldwide, royalty-free license to store, process, and display your User Content solely to operate, maintain, and improve the App, in accordance with our [Privacy Policy].</p>
          <p><strong>c. Prohibited Content</strong><br />
          You agree not to upload or share content that:</p>
          <ul>
            <li>Infringes on intellectual-property rights</li>
            <li>Violates laws or privacy rights</li>
            <li>Contains malware or spam</li>
            <li>Is harmful, threatening, or offensive</li>
          </ul>

          <h2>6. Third-Party Services</h2>
          <p>The App may integrate with third-party APIs or services (e.g., Firebase Authentication, AI recognition, analytics, or cloud storage).</p>
          <p>Use of these services is governed by their own terms and privacy policies.</p>
          <p>We ensure all integrations comply with Apple's App Store Guidelines and applicable data-protection laws.</p>

          <h2>7. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Reverse-engineer, decompile, or attempt to extract source code</li>
            <li>Interfere with or overload our servers</li>
            <li>Use automated scripts or bots</li>
            <li>Harass, impersonate, or abuse other users</li>
            <li>Use the App for commercial purposes without written consent</li>
            <li>Share your account with others</li>
          </ul>
          <p>Violation of this section may result in suspension or termination of your account.</p>

          <h2>8. Intellectual Property</h2>
          <p>All intellectual property rights in the App — including its design, features, patterns, tutorials, and trademarks — are owned by Croqly and protected under U.S. and international laws.</p>
          <p>Except for your User Content, nothing in these Terms transfers ownership rights to you.</p>

          <h2>9. Termination</h2>
          <p>You may delete your account at any time via the in-app account-deletion feature or by contacting us at <a href="mailto:itarnaevents2@gmail.com" className="contact-link">itarnaevents2@gmail.com</a>.</p>
          <p>We may suspend or terminate your account if you violate these Terms or applicable law.</p>
          <p>Upon termination, your right to use the App ends immediately.</p>
          <p>Sections 8 through 13 will survive termination.</p>

          <h2>10. Disclaimers</h2>
          <p>The App is provided "AS IS" and "AS AVAILABLE."</p>
          <p>To the fullest extent permitted by law, we disclaim all warranties, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.</p>
          <p>Crochet and knitting results may vary. Always use safe crafting practices and verify measurements before applying project instructions.</p>

          <h2>11. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Croqly is not liable for any indirect, incidental, special, or consequential damages — including data loss, profit loss, or business interruption — resulting from your use or inability to use the App.</p>
          <p>Some jurisdictions do not allow certain limitations; in such cases, our liability is limited to the maximum extent permitted by law.</p>

          <h2>12. Indemnification</h2>
          <p>You agree to indemnify and hold harmless Croqly, its officers, employees, and affiliates from any claims, damages, or expenses (including attorney fees) arising from:</p>
          <ul>
            <li>Your breach of these Terms, or</li>
            <li>Your misuse of the App</li>
          </ul>

          <h2>13. Governing Law & Dispute Resolution</h2>
          <p>These Terms are governed by the laws of the State of California, USA, without regard to conflict-of-law principles.</p>
          <p>Any disputes shall be resolved exclusively in the state or federal courts of San Francisco County, unless local consumer-protection laws require otherwise.</p>

          <h2>14. Changes to These Terms</h2>
          <p>We may update these Terms periodically. Material changes will be announced in-app or by email at least 7 days before they take effect. Continued use of the App after such notice constitutes your acceptance of the revised Terms.</p>

          <h2>15. Contact</h2>
          <p><strong>Croqly – Crochet & Knitting Companion</strong><br />
          Email: <a href="mailto:itarnaevents2@gmail.com" className="contact-link">itarnaevents2@gmail.com</a></p>
          <p>Apple Inc. is not responsible for the App's content, performance, or customer support.<br />
          All user inquiries should be directed to Croqly.</p>
          <p>These Terms of Service are effective as of January 15, 2025, and govern your use of the Croqly app.</p>
        </main>
      </div>

      <footer>
        <div className="container">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div>
              <p>&copy; 2025 Croqly. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;